(function() {
  const announcementBar = document.getElementById('announcementBar');
  const header = document.querySelector('.new-custom-header');
  
  if (!announcementBar || !header) return;
  
  let isHidden = false;
  
  function setInitialState() {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollY > 0) {
      announcementBar.classList.add('hidden');
      header.classList.remove('has-announcement-bar');
      isHidden = true;
    } else {
      announcementBar.classList.remove('hidden');
      header.classList.add('has-announcement-bar');
      isHidden = false;
    }
  }
  
  setInitialState();
  
  setTimeout(setInitialState, 50);
  setTimeout(setInitialState, 100);
  setTimeout(setInitialState, 250);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setInitialState);
  }
  
  window.addEventListener('load', setInitialState);
  
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      setTimeout(setInitialState, 50);
    }
  });
  
  function handleScroll() {
    const scrollY = window.scrollY;
    
    if (scrollY <= 150) {
      if (scrollY === 0) {
        if (isHidden) {
          announcementBar.classList.remove('hidden');
          header.classList.add('has-announcement-bar');
          isHidden = false;
        }
      }
      else if (scrollY > 0) {
        if (!isHidden) {
          announcementBar.classList.add('hidden');
          header.classList.remove('has-announcement-bar');
          isHidden = true;
        }
      }
    }
  }
  
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  document.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
})();